/* ============================================
   A by AMC — Spring Campaign Scripts
   ============================================ */

// (Add-to-cart uses Shopify's /cart/{variant_id}:1 permalink URL — no JS needed)

// ---- Sync nav top with announce-bar height (handles multi-line wrapping on mobile) ----
(function () {
    if (window.__abyamcMgBarSync) return;
    window.__abyamcMgBarSync = true;
    function update() {
        var bar = document.querySelector('.abyamc-mg-scope .announce-bar');
        if (!bar) return;
        document.documentElement.style.setProperty('--abyamc-mg-bar-height', bar.offsetHeight + 'px');
    }
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', update);
    } else {
        update();
    }
    window.addEventListener('resize', update, { passive: true });
    if (typeof ResizeObserver === 'function') {
        var bar = document.querySelector('.abyamc-mg-scope .announce-bar');
        if (bar) new ResizeObserver(update).observe(bar);
    }
})();

// ---- Nav transparency + scroll effect ----
(function () {
    const nav = document.getElementById('nav');
    if (!nav) return;

    window.addEventListener('scroll', () => {
        nav.classList.toggle('scrolled', window.scrollY > 60);
    }, { passive: true });

    // Set initial state
    nav.classList.toggle('scrolled', window.scrollY > 60);
})();

// ---- Proof bar animated counters ----
(function () {
    const stats = document.querySelectorAll('.proof-stat-number');
    if (!stats.length) return;

    const animateCounter = (el) => {
        const target = parseInt(el.dataset.target, 10);
        if (isNaN(target)) return;

        const duration = 1500;
        const start = performance.now();

        const tick = (now) => {
            const elapsed = now - start;
            const progress = Math.min(elapsed / duration, 1);
            // Ease-out cubic
            const eased = 1 - Math.pow(1 - progress, 3);
            el.textContent = Math.round(eased * target);

            if (progress < 1) {
                requestAnimationFrame(tick);
            }
        };

        requestAnimationFrame(tick);
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                animateCounter(entry.target);
                observer.unobserve(entry.target);
            }
        });
    }, { threshold: 0.5 });

    stats.forEach(el => observer.observe(el));
})();

// ---- Scroll Reveal ----
(function () {
    const selectors = [
        '.hero-content',
        '.proof-stat',
        '.narrative-problem', '.narrative-solution',
        '.product-image-col', '.product-text-col',
        '.explore-image-wrap',
        // NOTE: .explore-detail intentionally excluded — its `transform` from reveal-up
        // would create a containing block that breaks the mobile popup's position:fixed.
        '.lifestyle-item',
        '.step',
        '.recipes-text', '.recipes-image',
        '.trust-item',
        '.cta-inner',
    ];

    selectors.forEach(sel => {
        document.querySelectorAll(sel).forEach((el, i) => {
            el.classList.add('reveal-up');
            el.style.transitionDelay = (i * 0.06) + 's';
        });
    });

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('visible');
            }
        });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('.reveal-up').forEach(el => observer.observe(el));
})();

// ---- Explore System hotspot interaction ----
(function () {
    if (window.__abyamcMgExplorerInit) return;
    window.__abyamcMgExplorerInit = true;

    const card = document.getElementById('explore-card');
    const hotspots = document.querySelectorAll('.hotspot');
    if (!card || !hotspots.length) return;

    function getComponent(btn) {
        return {
            title: btn.dataset.title || '',
            desc: btn.dataset.desc || '',
            tag: btn.dataset.tag || '',
            iconUrl: btn.dataset.iconUrl || '',
            iconAlt: btn.dataset.iconAlt || ''
        };
    }

    const backdrop = document.querySelector('[data-explore-backdrop]');
    const closeBtn = card.querySelector('[data-explore-close]');

    function isMobile() {
        return window.matchMedia('(max-width: 900px)').matches;
    }

    function openPopup() {
        card.classList.add('is-popup-open');
        if (backdrop) backdrop.classList.add('is-open');
        document.body.classList.add('abyamc-mg-popup-open');
    }

    function closePopup() {
        card.classList.remove('is-popup-open');
        if (backdrop) backdrop.classList.remove('is-open');
        document.body.classList.remove('abyamc-mg-popup-open');
    }
    // Expose globally so inline onclick handlers in markup can call it
    window.abyamcMgClosePopup = closePopup;

    function setActive(index, openOnMobile) {
        hotspots.forEach(h => h.classList.remove('active'));
        hotspots[index].classList.add('active');

        card.classList.remove('active');
        setTimeout(() => {
            const c = getComponent(hotspots[index]);
            const iconEl = card.querySelector('.explore-card-icon');
            if (c.iconUrl) {
                const safeAlt = (c.iconAlt || '').replace(/"/g, '&quot;');
                iconEl.innerHTML = '<img src="' + c.iconUrl + '" alt="' + safeAlt + '">';
            } else {
                iconEl.innerHTML = '';
            }
            card.querySelector('.explore-card-title').textContent = c.title;
            card.querySelector('.explore-card-desc').textContent = c.desc;
            card.querySelector('.explore-card-tag').textContent = c.tag;
            card.classList.add('active');

            if (openOnMobile && isMobile()) openPopup();
        }, 150);
    }

    hotspots.forEach((btn, i) => {
        btn.addEventListener('click', () => setActive(i, true));
    });

    // Close button and backdrop use inline onclick="window.abyamcMgClosePopup()"
    // (more reliable than event listeners — bypasses any host theme interception)
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closePopup(); });
    // Auto-close if user resizes from mobile to desktop
    window.addEventListener('resize', () => { if (!isMobile()) closePopup(); });

    // Auto-activate first hotspot when section enters viewport — DESKTOP ONLY.
    // On mobile, no hotspot is active until the user taps one (so no popup appears
    // unprompted on scroll).
    const section = document.querySelector('.explore-system');
    if (section && !isMobile()) {
        const obs = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
                setActive(0);
                obs.disconnect();
            }
        }, { threshold: 0.3 });
        obs.observe(section);
    }
})();

// ---- Sticky mobile CTA: reveal after hero (or product overview if hero is disabled) ----
(function () {
    const sticky = document.getElementById('sticky-cta');
    if (!sticky) return;
    const trigger = document.querySelector('.hero') || document.querySelector('.product-section');
    if (!trigger) return;

    const obs = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            const passedTrigger = !entry.isIntersecting;
            sticky.classList.toggle('visible', passedTrigger);
            sticky.setAttribute('aria-hidden', passedTrigger ? 'false' : 'true');
            document.body.classList.toggle('sticky-cta-active', passedTrigger);
        });
    }, { threshold: 0, rootMargin: '-80% 0px 0px 0px' });

    obs.observe(trigger);
})();

// ---- Smooth scroll for anchor links ----
document.querySelectorAll('a[href^="#"]').forEach(link => {
    link.addEventListener('click', (e) => {
        const href = link.getAttribute('href');
        if (href === '#') return;
        const target = document.querySelector(href);
        if (target) {
            e.preventDefault();
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    });
});
